import { FETCH_TAKE_NOTES, ADD_TAKE_NOTES, UPDATE_TAKE_NOTES } from "src/shared/config";
import { ApiResponse } from "src/shared/types";
import { AddNotesPayload } from "src/store/takeNotes";
import appFetch from "src/shared/fetch";

type UpdateNotesParam = {
  data: any;
  userDetails: {
    pinId: number;
  };
};

type GetNotesParam = {
  userDetails: {
    pinId: string;
  };
  selectedTabValue: string;
};

export const getNotes = ({ userDetails, selectedTabValue }: GetNotesParam): ApiResponse =>
  appFetch.get(`${FETCH_TAKE_NOTES}/${userDetails.pinId}/`, {
    headers: { "X-Clear-Cache": "true" },
    params: {
      notes_enabled: "true",
      timeTab: selectedTabValue,
    },
  });

export const addNotes = ({ userDetails, data }: AddNotesPayload): ApiResponse =>
  appFetch.post(`${ADD_TAKE_NOTES}/${userDetails.pinId}/notes`, {
    headers: { "Content-Type": "application/json" },
    body: data,
    statusMessageConfig: {
      2: "Note was added successfully",
      4: "There was some error adding notes. Please try again",
      5: "There was some error adding notes. Please try again",
    },
  });

export const updateNotes = ({ userDetails, data }: UpdateNotesParam): ApiResponse =>
  appFetch.put(`${UPDATE_TAKE_NOTES}/${userDetails.pinId}/`, {
    body: data,
    headers: { "Content-Type": "application/json" },
    isRawResponse: true,
    statusMessageConfig: {
      2: "Notes were updated successfully",
      4: "There was some error updating notes. Please try again",
      5: "There was some error updating notes. Please try again",
    },
  });
